module.exports = __webpack_public_path__ + "static/img/娄强.bd31852f.png";